import store from "./src/store";

export default {
    ...store.getters.getConfigVars,
    backend_url: process.env.VUE_APP_BACKEND_URL,
    portal_instance_id: store.getters.getConfigVars ? store.getters.getConfigVars.id : null,
};
